// import { useState, useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
// import validator from 'validator'

// import Spinner from '../Layout/Spinner'
// import { getAgentInfo, manageUsers } from "../../features/contractSlice"


// const ManageUsers = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()

//     const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
//     const { agentInfo, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

//     const [users, setUsers] = useState([])
//     const [newUser, setNewUser] = useState("")
//     const [error, setError] = useState(false)
//     const [errorMessage, setErrorMessage] = useState("")
//     const [successMessage, setSuccessMessage] = useState("")
//     const [submitButtonVisible, setSubmitButtonVisible] = useState(false)

//     // useEffect(() => {
//     //     dispatch(getAgentInfo({ role, email, agentEmail, idToken }))
//     //     console.log("agentInfo", agentInfo)
//     //     if (agentInfo.subscription_users) {
//     //         setUsers(agentInfo.subscription_users)
//     //     }
//     // }, [])

//     useEffect(() => {
//         dispatch(getAgentInfo({ role, email, agentEmail, idToken }))
//     }, [dispatch, role, email, agentEmail, idToken])

//     // Add a separate effect to handle agentInfo updates
//     useEffect(() => {
//         if (agentInfo?.subscription_users) {
//             setUsers(agentInfo.subscription_users)
//         }
//     }, [agentInfo])


//     const handleAddUser = () => {
//         setError(false)
//         setErrorMessage("")

//         if (validator.isEmpty(newUser)) {
//             setError(true)
//             setErrorMessage("Cannot be empty")
//         } else if (!validator.isEmail(newUser)) {
//             setError(true)
//             setErrorMessage("Please enter valid email")
//         } else if (users.length > 3) {
//             setError(true)
//             setErrorMessage("You can have upto 4 users")
//         } else {
//             let lowercaseEmail = newUser.toLowerCase()
//             setUsers([...users, newUser])
//             setNewUser("")
//             setSubmitButtonVisible(true)
//         }

//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()

//         if (users.length > 4) {
//             setError(true)
//             setErrorMessage("You can have upto 4 users")
//         } else {
//             const data = {
//                 email: email,
//                 subscription_users: users
//             }

//             dispatch(manageUsers({ data, idToken }))
//                 .unwrap()
//                 .then(() => {
//                     setSuccessMessage('Updated Users successfully')
//                     setSubmitButtonVisible(false)
//                     // navigate("/sub/add-users")
//                 })
//                 .catch((error) => {
//                     console.error('Error updating users:', error);
//                 });
//         }
//     }

//     if (loading) return <Spinner />

//     return (
//         <div className='min-h-screen'>
//             <div className='container-xl lg:container m-auto px-4 py-6'>
//                 {agentInfo && (
//                     <div>
//                         <div className='font-bold text-xl m-5'>Manage users for {email}</div>
//                         {setSuccessMessage && (<div className='text-sm italic text-green-500'>{successMessage}</div>)}
//                         {users.length < 4 && (
//                             <div>
//                                 <div className='font-bold mt-5'>Add a new user</div>
//                                 <div className='grid grid-cols-1 md:grid-cols-3 gap-2'>
//                                     <input
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40l md:col-span-2'
//                                         type="email"
//                                         placeholder='User email'
//                                         value={newUser}
//                                         onChange={(e) => {
//                                             setNewUser(e.target.value)
//                                             setSuccessMessage("")
//                                         }}
//                                     />
//                                     <button
//                                         className='uppercase font-bold text-blue-600 text-left col-span-1'
//                                         onClick={handleAddUser}
//                                     >
//                                         Add
//                                     </button>
//                                 </div>
//                                 {error && (
//                                     <div className='italic text-sm text-red-600'>{errorMessage}</div>
//                                 )}
//                             </div>
//                         )}

//                         <div className='mt-4'>
//                             <div className='font-bold mt-5'>Users</div>
//                             {users && users.map((user, index) => {
//                                 return (
//                                     <div key={index} className='grid grid-cols-1 md:grid-cols-3 gap-2'>
//                                         <div className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40l col-span-2'>{user}</div>
//                                         <button
//                                             className='uppercase font-bold text-red-600 text-left md:col-span-1 pt-1'
//                                             onClick={() => {
//                                                 setUsers(users.filter((u, i) => i !== index))
//                                                 setSubmitButtonVisible(true)
//                                             }}
//                                         >
//                                             Delete
//                                         </button>
//                                     </div>
//                                 )
//                             })}
//                         </div>

//                         {submitButtonVisible && (<div className='mt-5'>
//                             <form onSubmit={handleSubmit}>
//                                 <button type="submit" className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-indigo-700 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600">
//                                     Submit Changes
//                                 </button>
//                             </form>
//                         </div>)}

//                     </div>
//                 )}

//             </div>
//         </div>
//     )
// }

// export default ManageUsers

import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import validator from 'validator'

import Spinner from '../Layout/Spinner'
import { getAgentInfo, manageUsers } from "../../features/contractSlice"

const ManageUsers = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
    const { agentInfo, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

    const [users, setUsers] = useState([])
    const [newUser, setNewUser] = useState("")
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [successMessage, setSuccessMessage] = useState("")
    const [submitButtonVisible, setSubmitButtonVisible] = useState(false)

    useEffect(() => {
        dispatch(getAgentInfo({ role, email, agentEmail, idToken }))
    }, [dispatch, role, email, agentEmail, idToken])

    useEffect(() => {
        if (agentInfo?.subscription_users) {
            setUsers(agentInfo.subscription_users)
        }
    }, [agentInfo])

    const handleAddUser = () => {
        setError(false)
        setErrorMessage("")

        if (validator.isEmpty(newUser)) {
            setError(true)
            setErrorMessage("Cannot be empty")
        } else if (!validator.isEmail(newUser)) {
            setError(true)
            setErrorMessage("Please enter valid email")
        } else if (users.length > 3) {
            setError(true)
            setErrorMessage("You can have up to 4 users")
        } else {
            let lowercaseEmail = newUser.toLowerCase()
            setUsers([...users, lowercaseEmail])
            setNewUser("")
            setSubmitButtonVisible(true)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (users.length > 4) {
            setError(true)
            setErrorMessage("You can have up to 4 users")
        } else {
            const data = {
                email: email,
                subscription_users: users
            }

            dispatch(manageUsers({ data, idToken }))
                .unwrap()
                .then(() => {
                    setSuccessMessage('Users updated successfully')
                    setSubmitButtonVisible(false)
                })
                .catch((error) => {
                    console.error('Error updating users:', error);
                });
        }
    }

    if (loading) return <Spinner />

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="max-w-4xl mx-auto px-4 py-12">
                {agentInfo && (
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                            <h1 className="text-xl font-bold text-white">Manage Team Access</h1>
                            <p className="text-blue-100 text-sm mt-1">
                                Add or remove users who can access your subscription
                            </p>
                        </div>

                        <div className="p-6">
                            {successMessage && (
                                <div className="mb-6 bg-green-50 border-l-4 border-green-400 p-4 rounded-r-md">
                                    <div className="flex">
                                        <div className="flex-shrink-0">
                                            <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                        <div className="ml-3">
                                            <p className="text-sm text-green-700">{successMessage}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="mb-8">
                                <div className="flex items-center justify-between mb-4">
                                    <h2 className="text-lg font-medium text-gray-900">Current Users</h2>
                                    <span className="text-sm text-gray-500">{users.length}/4 users</span>
                                </div>

                                <div className="space-y-3">
                                    {users.length === 0 ? (
                                        <p className="text-gray-500 text-sm italic">No users added yet</p>
                                    ) : (
                                        users.map((user, index) => (
                                            <div key={index} className="flex items-center justify-between bg-gray-50 rounded-lg p-3 border border-gray-200">
                                                <div className="flex items-center">
                                                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-medium">
                                                        {user.charAt(0).toUpperCase()}
                                                    </div>
                                                    <span className="ml-3 text-gray-700">{user}</span>
                                                </div>
                                                <button
                                                    className="text-sm text-red-600 hover:text-red-800 font-medium flex items-center"
                                                    onClick={() => {
                                                        setUsers(users.filter((u, i) => i !== index))
                                                        setSubmitButtonVisible(true)
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                                    </svg>
                                                    Remove
                                                </button>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            {users.length < 4 && (
                                <div className="mb-8">
                                    <h2 className="text-lg font-medium text-gray-900 mb-4">Add New User</h2>
                                    <div className="flex">
                                        <div className="flex-grow">
                                            <input
                                                className="w-full px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                type="email"
                                                placeholder="Enter email address"
                                                value={newUser}
                                                onChange={(e) => {
                                                    setNewUser(e.target.value)
                                                    setSuccessMessage("")
                                                }}
                                            />
                                            {error && (
                                                <p className="mt-1 text-sm text-red-600">{errorMessage}</p>
                                            )}
                                        </div>
                                        <button
                                            className="px-4 py-2 bg-blue-600 text-white font-medium rounded-r-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                            onClick={handleAddUser}
                                        >
                                            Add User
                                        </button>
                                    </div>
                                </div>
                            )}

                            {submitButtonVisible && (
                                <div className="pt-4 border-t border-gray-200">
                                    <form onSubmit={handleSubmit}>
                                        <button
                                            type="submit"
                                            className="w-full px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                                        >
                                            Save Changes
                                        </button>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ManageUsers
